import angular from 'angular';

angular.module('commonServices').factory('openIbanSvc', ['$q', '$http', 'appUrls', openIbanSvc]);

function openIbanSvc($q, $http, appUrls) {
  var getBic = function(iban) {
    var deferred = $q.defer();
    $http.get(appUrls.api + '/api/transaction/bic/' + iban).then(
      function(data) {
        var result = data;
        if (!result) {
          deferred.reject({
            code: '06018',
            parameters: [],
          });
          return;
        }
        if (result.data) {
          deferred.resolve(result.data);
        } else {
          deferred.resolve('');
        }
      },
      function(error) {
        if (error) console.error(error);
        deferred.reject({
          code: '00032',
          parameters: error,
        });
      },
    );

    return deferred.promise;
  };

  return {
    getBic: getBic,
  };
}
